import ApiService from './api.service'

const PenaltyService = {
  index (page = 1, schedule) {
    return ApiService.get(`api/v2/admin/penalties?page=${page}&schedule=${schedule ?? ''}`)
  }
}

export default PenaltyService
